export interface SwitcherClient {
    id: string;
    name: string;
}

export interface ClientSections {
    recent: SwitcherClient[];
    rest: SwitcherClient[];
}

export function getClientInitials(name: string): string {
    return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word.charAt(0).toUpperCase())
        .join('');
}

export function filterClientsByName(clients: SwitcherClient[], query: string): SwitcherClient[] {
    const needle = query.trim().toLowerCase();
    if (!needle) return clients;
    return clients.filter((client) => client.name.toLowerCase().includes(needle));
}

export function buildClientSections(
    clients: SwitcherClient[],
    recentClientIds: string[],
    query: string,
): ClientSections {
    const clientsById = new Map(clients.map((client) => [client.id, client]));
    const recentClients = recentClientIds
        .map((id) => clientsById.get(id))
        .filter((client): client is SwitcherClient => client !== undefined);
    const recentIds = new Set(recentClients.map((client) => client.id));
    const restClients = clients
        .filter((client) => !recentIds.has(client.id))
        .sort((a, b) => a.name.localeCompare(b.name));

    return {
        recent: filterClientsByName(recentClients, query),
        rest: filterClientsByName(restClients, query),
    };
}
